import { render, staticRenderFns } from "./langhamConnected.vue?vue&type=template&id=32e0b4b6&scoped=true&"
import script from "./langhamConnected.vue?vue&type=script&lang=js&"
export * from "./langhamConnected.vue?vue&type=script&lang=js&"
import style0 from "./langhamConnected.vue?vue&type=style&index=0&id=32e0b4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0b4b6",
  null
  
)

export default component.exports